import React, { useContext, useEffect } from "react";
import { Navigate } from "react-router-dom";
import styled from "styled-components";
import { useTheme, Container, Typography } from "@material-ui/core";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import Header from "../components/layout/Header/Header";
import Footer from "../components/layout/Footer";
import Pane from "../components/layout/Pane/Pane";
import Tabs from "../components/layout/Pane/Tabs";
import LabelImportantIcon from "@material-ui/icons/LabelImportant";
import SRCSVImport from "../components/Import/SRCSVImport";
import IDCSVImport from "../components/Import/IDCSVImport";
import DOCOMMImport from "../components/Import/DOCOMMImport";
import PhotoImport from "../components/Import/PhotoImport";
import SynchronizeImport from "../components/Import/SynchronizeImport";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import { UserContext } from "../contexts/UserContext";
import { PaneContext } from "../contexts/PaneContext";

const Import = () => {
  const { id, Site } = useContext(UserContext);
  const { changeTab } = useContext(PaneContext);

  const { palette } = useTheme();

  useEffect(() => {
    changeTab(0);
    //eslint-disable-next-line
  }, []);

  return !id ? (
    <Navigate to="/" />
  ) : (
    <PageContainer>
      <Header />
      <Container>
        <ImportPane
          subHeader={
            <Typography style={Tstyles}>
              <LabelImportantIcon style={iconStyles1} /> Import Data
            </Typography>
          }
          variant="import"
          colour={palette.success.main}
        >
          <Tabs
            colour="success"
            data={[
              {
                index: 0,
                title: "CSV",
                title: (
                  <Typography style={Tstyles}>
                    {" "}
                    <InsertDriveFileIcon style={iconStyles} /> CSV
                  </Typography>
                ),
                component:
                  Site.siteType != 0 &&
                  Site.siteType != 5 &&
                  Site.siteType != 6 ? (
                    <IDCSVImport />
                  ) : Site.siteType != 6 ? (
                    <SRCSVImport />
                  ) : (
                    <DOCOMMImport />
                  ),
              },
              {
                index: 1,
                title: "Photos",
                title: (
                  <Typography style={Tstyles}>
                    {" "}
                    <CameraAltIcon style={iconStyles} /> Photos
                  </Typography>
                ),
                component: <PhotoImport />,
              },
              {
                index: 2,
                title: "Synchronize",
                title: (
                  <Typography style={Tstyles}>
                    {" "}
                    <SyncAltIcon style={iconStyles} /> Synchronise
                  </Typography>
                ),
                component: <SynchronizeImport />,
              },
            ]}
          />
        </ImportPane>
      </Container>
      <Footer />
    </PageContainer>
  );
};

const iconStyles = {
  fontSize: "16px",
};

const iconStyles1 = {
  fontSize: "16px",
};

const Tstyles = {
  fontWeight: "Bold",
  fontSize: "16px",
};

const PageContainer = styled.main`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ImportPane = styled(Pane)`
  flex: none;
  margin-bottom: 2rem;
  margin-top: 4rem;
`;

export default Import;
